import {AthubRestResource} from "@/api/rest";
import {DCIM_SERVER} from "@/api";
import athubAxios from "@/util/athub-axios/core";

const equipmentGroupItem = new AthubRestResource({server: DCIM_SERVER, resource: 'equipment-group-item'});

equipmentGroupItem.removeByGroupIdAndItemId = (groupId, itemId, config) => {
    return equipmentGroupItem.handlePromise(
        athubAxios.delete(`${equipmentGroupItem.server}/${equipmentGroupItem.resource}/group-id/${groupId}/item-id/${itemId}`,
            config));
};

export default equipmentGroupItem;
